/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_overArg.js
 ** module id = 186
 ** module chunks = 35
 **/